import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  onClose: () => void
  onConfirm: () => void
  showModal: boolean
}

export default function PortfolioTaxableConfirmModal({
  showModal,
  onClose,
  onConfirm,
}: Props) {
  const title = 'Marking This Portfolio As Taxable'
  const buttonConfirmText = 'Mark Portfolio Taxable'

  return (
    <Modal isCentered isOpen={showModal} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          paddingBottom={SIZE.s12}
          paddingLeft={SIZE.s32}
          paddingRight={SIZE.s32}
          paddingTop={SIZE.s32}
        >
          <PDSHeader variant="h4">{title}</PDSHeader>
        </ModalHeader>
        <ModalBody
          paddingBottom={SIZE.s32}
          paddingLeft={SIZE.s32}
          paddingRight={SIZE.s32}
        >
          <PDSBox display="grid" gap={SIZE.s20}>
            <PDSText size="md">
              Pave Securities does not provide tax advice, and nothing on this
              site should be construed as such.
            </PDSText>
            <PDSText size="md">
              You are strongly encouraged to consult with your tax advisor
              before making any investment decisions or implementing any
              portfolio strategies, to fully understand the potential tax
              implications based on individual circumstances.
            </PDSText>
          </PDSBox>
        </ModalBody>

        <PDSSeparator />
        <ModalFooter padding={`${SIZE.s24} ${SIZE.s40}`}>
          <PDSFlexBox flexDirection="column" gap={SIZE.s16} width="100%">
            <PDSButton
              onClick={onConfirm}
              size="md-f"
              text={buttonConfirmText}
              testId="taxable-modal-confirm"
              variant="primary"
            />
            <PDSButton
              onClick={onClose}
              size="md-f"
              testId="taxable-modal-cancel"
              text="Cancel"
              variant="tertiary"
            />
          </PDSFlexBox>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
